module.exports = __webpack_public_path__ + "static/media/p2008cover.2a7512da.jpg";